module.exports = __webpack_public_path__ + "img/rightside_100.c3371d98.jpg";